import React from "react";
import { Link } from "react-router-dom";
import { formatPublishDate } from "../../utils/blogHelpers";

const BlogCard = ({ post }) => {
  if (!post) return null;

  const categoryLabel = post.categoryName || post.category || "Blog";
  const categoryQuery = post.category || post.categoryId;

  return (
    <article className="azzir-blog-card">
      <Link to={`/blog/${post.slug}`} className="azzir-blog-card__media">
        <img
          src={post.cardImage || post.featuredImage}
          alt={post.title}
          loading="lazy"
        />
      </Link>
      <div className="azzir-blog-card__body">
        <div className="azzir-blog-card__meta">
          {categoryQuery ? (
            <Link
              to={`/blog?category=${categoryQuery}`}
              className="azzir-blog-card__cat"
            >
              {categoryLabel}
            </Link>
          ) : (
            <span className="azzir-blog-card__cat">{categoryLabel}</span>
          )}
          <span className="azzir-blog-card__dot">•</span>
          <time dateTime={post.publishDate}>
            {formatPublishDate(post.publishDate)}
          </time>
          {post.readTime ? (
            <>
              <span className="azzir-blog-card__dot">•</span>
              <span>{post.readTime}</span>
            </>
          ) : null}
        </div>
        <h3 className="azzir-blog-card__title">
          <Link to={`/blog/${post.slug}`}>{post.title}</Link>
        </h3>
        {post.excerpt ? (
          <p className="azzir-blog-card__excerpt">{post.excerpt}</p>
        ) : null}
        <Link to={`/blog/${post.slug}`} className="azzir-blog-card__more">
          Read More <i className="fas fa-arrow-right" aria-hidden="true" />
        </Link>
      </div>
    </article>
  );
};

export default BlogCard;
